export function formatAddress(address: AddressType) {
    const addressLine1 = [address.street1, address.street2, address.street3]
        .filter((x) => x)
        .join(', ');
    const addressLine2 = `${address.municipality}, ${address.administrative_area} ${address.postal_code}`;
    return [addressLine1, addressLine2];
}
